import React from "react";

const LoadingCharge = () => {
	return (
		<div className="loading-charge">
			<div className="container">
				<div className="lds-dual-ring"></div>
				<h1>Loading, wait a moment...</h1>
			</div>
		</div>
	);
};

export default LoadingCharge;
